import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Popover } from "@mui/material";

interface VariableContextMenuProps {
  anchorEl: HTMLButtonElement | null;
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  canEdit?: boolean;
  canDuplicate?: boolean;
  canDelete?: boolean;
}

export default function VariableContextMenu({
  anchorEl,
  open,
  onClose,
  onEdit,
  onDuplicate,
  onDelete,
  canEdit = true,
  canDuplicate = true,
  canDelete = true,
}: VariableContextMenuProps) {
  const handleEdit = () => {
    onEdit();
    onClose();
  };

  const handleDuplicate = () => {
    onDuplicate();
    onClose();
  };

  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        style: {
          borderRadius: "10px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
          padding: "6px",
          minWidth: "160px",
          backgroundColor: "var(--pi-surface)",
        },
      }}
    >
      <div className="flex flex-col">
        {/* Edit Option */}
        {canEdit && (
          <button
            onClick={handleEdit}
            className="flex items-center gap-3 px-3 py-2.5 hover:bg-creator-primary-background rounded-md transition-colors cursor-pointer outline-none"
          >
            <EditIcon sx={{ fontSize: 20 }} className="text-creator-primary" />
            <span className="text-[14px] font-medium text-creator-text-sub font-poppins">
              Edit
            </span>
          </button>
        )}

        {/* Duplicate Option */}
        {canDuplicate && (
          <button
            onClick={handleDuplicate}
            className="flex items-center gap-3 px-3 py-2.5 hover:bg-creator-primary-background rounded-md transition-colors cursor-pointer outline-none"
          >
            <ContentCopyIcon
              sx={{ fontSize: 20 }}
              className="text-creator-primary"
            />
            <span className="text-[14px] font-medium text-creator-text-sub font-poppins">
              Duplicate
            </span>
          </button>
        )}

        {/* Delete Option */}
        {canDelete && (
          <button
            onClick={handleDelete}
            className="flex items-center gap-3 px-3 py-2.5 hover:bg-creator-primary-background rounded-md transition-colors cursor-pointer outline-none"
          >
            <DeleteOutlineOutlinedIcon
              sx={{ fontSize: 20 }}
              className="text-creator-error"
            />
            <span className="text-[14px] font-medium text-creator-error font-poppins">
              Delete
            </span>
          </button>
        )}
      </div>
    </Popover>
  );
}
